import { render } from "./ButtonsAccueil.vue?vue&type=template&id=4484b50a&scoped=true"
import script from "./ButtonsAccueil.vue?vue&type=script&lang=js"
export * from "./ButtonsAccueil.vue?vue&type=script&lang=js"

import "./ButtonsAccueil.vue?vue&type=style&index=0&id=4484b50a&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4484b50a"]])

export default __exports__